import React, {useState} from 'react';
import LightboxImage from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';

const Lightbox = ({patch, className}) => {
    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    if (patch.length === 0) {
        return '';
    }

    const lightBoxClassName = className !== undefined ? className : '';

    const images = patch;

    const prev = images.map((el, i) => (
        <div className={`${lightBoxClassName}__item`} key={i} onClick={() => {
            setPhotoIndex(i);
            setIsOpen(true);
        }}>
            <img src={el} alt={`Image ${i}`} />
        </div>
    ));

    return (
        <>
            <div className={lightBoxClassName}>
                {prev}
            </div>

            {isOpen && (
                <LightboxImage
                    mainSrc={images[photoIndex]}
                    nextSrc={images[(photoIndex + 1) % images.length]}
                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() =>
                        setPhotoIndex((photoIndex + images.length - 1) % images.length)
                    }
                    onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % images.length)
                    }
                />
            )}
        </>
    );
};

export default Lightbox;
